import { Component } from '@angular/core';

@Component({
  selector: 'empathy-ranking-form',
  templateUrl: './ranking-form.component.html',
  styleUrls: ['./ranking-form.component.scss']
})
export class RankingFormComponent {}
